import React, { useEffect, useState } from 'react';
import { TopicStyles } from './StyleComponents/mixins/mixins';
import TopicStyle from './StyleComponents/topicStyle';

export default function StyleModalContent({
	style,
	setStyle,
	setModalOpen,
	setIsChanged,
	isChanged,
	setIsWarnModalOpen
}: {
	style: TopicStyles;
	setStyle: (style: TopicStyles) => void;
	setModalOpen: (isOpen: boolean) => void;
	isChanged: boolean;
	setIsChanged: (isChanged: boolean) => void;
	isWarnModalOpen: boolean;
	setIsWarnModalOpen: (isOpen: boolean) => void;
}) {
	const [styleCopy, setStyleCopy] = useState(style);
	const [isValid, setIsValid] = useState(true);

	useEffect(() => {
		if (style != styleCopy) setIsChanged(true);
		else setIsChanged(false);
	}, [styleCopy]);

	return (
		<div
			className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
						w-4/6 h-full md:h-auto ml-8 px-4 py-2 max-h-[80%] mt-10 flex flex-col"
		>
			<div
				className="relative bg-gray-300 w-full max-h-screen overflow-y-auto
									dark:bg-gray-900 transition-colors duration-300 rounded-t-xl"
			>
				<div className="flex flex-col justify-center px-4 py-2">
					<TopicStyle
						style={styleCopy}
						setStyle={setStyleCopy}
						setIsValid={setIsValid}
					/>
				</div>
			</div>

			<div
				className="flex flex-row justify-end pt-3 pb-2 px-6 space-x-2 -mt-1
						bg-gray-300 dark:bg-gray-900 shadow-lg transition-colors duration-300 rounded-b-xl"
			>
				<button
					data-modal-toggle="defaultModal"
					className="btn btn-outline btn-secondary btn-sm mr-1 "
					type="button"
					style={{ transition: 'all .15s ease' }}
					onClick={() => {
						if (isChanged) setIsWarnModalOpen(true);
						else {
							setModalOpen(false);
						}
					}}
				>
					Cancel
				</button>
				{isChanged && isValid && (
					<button
						data-modal-toggle="defaultModal"
						type="button"
						className="btn btn-outline btn-sm btn-primary mr-1"
						style={{ transition: 'all .15s ease' }}
						onClick={(e) => {
							e.stopPropagation();
							setStyle(styleCopy);
							if (setIsChanged) setIsChanged(true);
							setModalOpen(false);
						}}
					>
						Save
					</button>
				)}
			</div>
		</div>
	);
}
